<template>
  <div class="option">
    <a class="dropdownbtn"
        data-toggle="grauDropDown"
        @click="switchOption">
      <i class="fa fa-chevron-down"></i>
      <span class="value" v-if="modelValue == null">
        {{ defaultmsg }}
      </span>
      <span class="result" v-else>
        {{ modelValue.label }}
      </span>
      <span class="drop_linha"></span>
    </a>
    <div
        class="dropdown-pane" :class="{ 'is-open': isOpen }"
        id="grauDropDown"
        data-dropdown>
      <ul class="drop">
        <li :class="{ 'active': option == modelValue }"
            :key="option.title"
            v-for="option in options"
            @click="handleInput(option)">
          <a class="opt">
            {{ option.label }}
            <i class="cicloremove ms-Icon ms-Icon--Cancel"
               aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComboBox",
  props:["modelValue","defaultmsg","options","isOpen"],
  emits:["update:modelValue","update:openCombo","update:closeCombo"],
  created(){

  },
  methods:{
    handleInput(option) {
      const updatedOption = option != this.modelValue ? option : null;
      this.$emit('update:modelValue', updatedOption);
      this.$emit("update:closeCombo");
    },
    switchOption(){
      this.$emit("update:openCombo");
    }
  }
}
</script>

<style scoped>
/**202 - 334*/
.dropdownbtn,
.dropdownbtn:hover {
  display: inline-block;
  margin-left: 0;
  margin-bottom: 8px;
  cursor: pointer;
  color: #333333;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid black;
  border-radius: 5px;
  padding-bottom: 9px;
  font-family: "Montserrat Light",serif;
  font-size: 16px;
  padding-top: 10px;
}

.option {
  position: relative;
}

.value {
  font-family: 'Montserrat Light',serif;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  color: #6a6868;
}

ul.drop li:hover,
ul.drop li.active {
  background-color: #ccc;
}

.option .dropdown-pane {
  width: 100%;
  padding: 0;
}


.dropdownbtn i {
  margin-right: 25px;
  font-size: 17px;
  color: #333333;
  margin-left: 8px;
}

.drop {
  list-style-type: none;
  margin-bottom: 0;
  max-height: 450px;
  overflow-y: scroll;
}

.drop::-webkit-scrollbar {
  opacity: 0;
  width: 0;
}

.drop li {
  padding-left: 23px;
  padding-top: 7.5px;
  padding-bottom: 7.5px;
  position: relative;
}

.drop li a {
  color: black;
  line-height: 32px;
  padding-left: 8px;
  width: 100%;
  display: block;
  color: rgb(49, 49, 49);
  font-family: Montserrat,serif;
  font-size: 14.5px;
}

.cicloremove {
  display: none;
  float: left;
  margin-right: 0;
  z-index: 0;
  font-size: 14px;
  right: 10px;
  bottom: 0;
  position: absolute;
  top: 50%;
  transform: translate(-0%, -100%);
}

.active a.opt {
  position: relative;
}

.active .cicloremove {
  display: block;
  z-index: 0;
}

/*485 */
#grauDropDown{
  top: 45px;
}

@media (max-width: 1200px) {
  .dropdownbtn i {
    margin-right: 15px;
    font-size: 15px;
  }

  .drop li {
    padding-right: 20px;
    padding-left: 20px;
  }

  .drop {
    padding-top: 15px;
    padding-bottom: 20px;
  }

  .drop li a {
    line-height: 19px;
    padding-bottom: 9px;
  }

  .dropdownbtn {
    padding-top: 11px;
    padding-bottom: 8px;
  }
  
}


@media (min-width: 768px) and (max-width: 1024px) {
  /**618 */
  .value {
    font-size: 15px;
  }
}

@media (max-width: 767px) {
  /**711 */
  .value {
    font-size: 14px;
  }

  .drop li {
    padding-left: 20px;
    padding-drop: 20px;
    font-size: 15px;
    padding-top: 15px;
  }

  .drop li a {
    line-height: 18px;
  }

  .drop {
    padding-top: 10px;
    padding-bottom: 25px;
  }

  .dropdownbtn,
  .dropdownbtn:hover {
    font-family: "Montserrat Light",serif;
    font-size: 14px;
    padding-top: 10px;
  }

}
</style>